import { useRef, useState } from 'react';

import { useTheme } from '@mui/material/styles';
import { Box, ClickAwayListener, Grid, List, ListItemButton, ListItemText, Paper, Popper, Typography, useMediaQuery } from '@mui/material';
import {useDispatch, useSelector} from "react-redux";

import IconButton from '../../../../Components/@extended/IconButton';
import Transitions from '../../../../Components/@extended/Transitions';


import { BankTwoTone } from '@ant-design/icons';
import MenuItem from "@mui/material/MenuItem";
// import { handlerSetSubscriptionSelect } from "../../../../store/reducer/xero_connection";
const XeroSubscriptions = (props) => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const {subscription_list, selected_subscription} = useSelector((state) => state.xeroconnection);
    const {username} = useSelector((state) => state.authuser);
    const iconBackColorOpen = 'grey.200';
    const iconBackColor = 'grey.100';
    const anchorRef = useRef(null);
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
      };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
          return;
        }
        setOpen(false);
      };

    const handleSubscriptionItemClick = (event, index) => {
        console.log(event);
        console.log(username)
        var selected_subscription = subscription_list.filter((sub) => {
            if (sub['organisation_id']===index){
                return sub
            }
        })

        dispatch(props.getSubscriptions(username))

        dispatch(props.handlerSetSubscriptionSelect({
            // selected_subscription: event.target.textContent
            selected_subscription: selected_subscription[0]
        }))
        dispatch(props.handlerResetPayables({
            list: null,
            pdf_data: "",
            details_error: null,
            error_message: ""
        }))
        // Update users list and other calls
        dispatch(props.getUsersList(username, selected_subscription[0]))
        setOpen(false);
    }

    return (
        <Box sx={{ flexShrink: 0, ml: 0.75 }}>
          <IconButton
            color="secondary"
            variant="light"
            sx={{ color: 'text.primary', bgcolor: open ? iconBackColorOpen : iconBackColor }}
            aria-label="open localization"
            ref={anchorRef}
            aria-controls={open ? 'localization-grow' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
          >
            <BankTwoTone />
          </IconButton>
          <Popper
              placement={'bottom'}
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
              popperOptions={{
                  modifiers: [
                      {
                          name: 'offset',
                          options: {
                              offset: [0]
                          }
                      }
                  ]
              }}
          >
              {({ TransitionProps }) => (
                  <Transitions type="grow" position={'top-right'} in={open} {...TransitionProps}>
                      <Paper xs={{ boxShadow: `0px 1px 1px rgb(0 0 0 / 14%), 0px 2px 1px rgb(0 0 0 / 12%), 0px 1px 3px rgb(0 0 0 / 20%)`}}>
                          <ClickAwayListener onClickAway={handleClose}>
                              <List
                                  component="nav"
                                  sx={{
                                    p: 0,
                                    width: '100%',
                                    minWidth: 200,
                                    maxWidth: 290,
                                    bgcolor: theme.palette.background.paper,
                                    borderRadius: 0.5,
                                    [theme.breakpoints.down('md')]: {
                                      maxWidth: 250
                                    }
                                  }}
                                >
                                  {subscription_list.map((subscription) =>
                                    <ListItemButton key={subscription['organisation_id']} selected={selected_subscription === subscription['organisation_name']} onClick={(event) => handleSubscriptionItemClick(event, subscription['organisation_id'])}>
                                        <ListItemText
                                          primary={
                                            <Grid container>
                                              <Typography color="textPrimary">{subscription['organisation_name']}</Typography>
                                            </Grid>
                                          }
                                        />
                                    </ListItemButton>
                                  )}
                              </List>
                          </ClickAwayListener>
                      </Paper>
                  </Transitions>
              )}
          </Popper>
        </Box>
    )
}

export default XeroSubscriptions;